import React from 'react';
import { motion } from 'framer-motion';
import { Star, BookOpen, AudioWaveform, FileText } from 'lucide-react';
function Stars() {
  return <div className="flex gap-0.5" data-id="element-17">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-gold fill-gold" strokeWidth={0} data-id="element-18" />)}
    </div>;
}
const items = [{
  icon: FileText,
  title: 'El Código Post-Ruptura (PDF)',
  desc: 'El protocolo completo de 72 horas para recuperar tu soberanía emocional.'
}, {
  icon: BookOpen,
  title: 'Bitácora de Soberanía (Journal)',
  desc: 'Checklists diarios, trackers de dopamina y ejercicios de reescritura de identidad.'
}, {
  icon: AudioWaveform,
  title: 'Audio SOS de Rescate Inmediato',
  desc: 'Tu salvavidas auditivo para cuando el impulso de contactarlo ataca.'
}];
export function BonusBundle() {
  return <section className="py-5 px-6 bg-black border-t border-gold/10 pt-[60px] pb-[60px]" data-id="element-19">
      <div className="max-w-3xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-center mb-4" data-id="element-21">
          <p className="font-sans text-[10px] text-gold uppercase tracking-[0.3em] mb-2" data-id="element-22">
            Lo que recibís hoy
          </p>
          <h2 className="font-cinzel text-3xl md:text-4xl text-white tracking-[0.1em] mb-2" data-id="element-23">
            EL PREMIUM <span className="text-gold" data-id="element-24">PACK</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.2
      }} className="relative mb-4 overflow-hidden rounded" data-id="element-25">
          <img src="https://cdn.magicpatterns.com/uploads/1zRHvv1eLKcirANDREFEAH/private_openrouter-generated-image-1775522964644.png" alt="El Código Premium Pack — eBook, journal y audio" className="w-full h-auto object-cover max-h-[480px]" data-id="element-26" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/30 pointer-events-none" data-id="element-27" />
        </motion.div>

        <div className="space-y-0" data-id="element-28">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: i * 0.15
        }} className="flex flex-col sm:flex-row items-center sm:items-start gap-3 py-4 border-b border-white/5 text-center sm:text-left" data-id="element-29">
              <div className="flex-shrink-0 w-12 h-12 rounded-full border border-gold/20 flex items-center justify-center" data-id="element-30">
                <item.icon className="w-5 h-5 text-gold" strokeWidth={1} data-id="element-31" />
              </div>
              <div className="flex-1" data-id="element-32">
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-1 justify-center sm:justify-start" data-id="element-33">
                  <h3 className="font-cinzel text-lg text-white tracking-widest" data-id="element-34">
                    {item.title}
                  </h3>
                  <Stars data-id="element-35" />
                </div>
                <p className="font-sans text-sm text-gray-500 font-light leading-relaxed" data-id="element-36">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}